import React from 'react'
import { useSelector } from 'react-redux';

const Loading = () => {
  const {loader} = useSelector((state) => state.Loader);
    
  return (
    <div
      className={`
        fixed inset-0 z-50 flex flex-col items-center justify-center
        transition-opacity duration-700 ease-in-out
        ${loader ? 'opacity-100 visible' : 'opacity-0 invisible'}
        bg-cs-bg-alt/80 backdrop-blur-sm
      `}
    >
      {/* Logo animado */}
      <div className="flex flex-col items-center">
        <div className="relative flex items-center justify-center">
          <img
            src="/logoB.png"
            alt="CargoSmart logo"
            className="h-16 w-auto object-contain animate-pulse"
          />
          {/* Spinner circular detrás del logo */}
          <div className="absolute inset-0 flex items-center justify-center">
            <div className="animate-spin rounded-full h-20 w-20 border-4 border-cs-primary border-t-transparent opacity-60"></div>
          </div>
        </div>

        {/* Texto animado */}
        <p className="mt-6 text-cs-muted text-xs tracking-wide animate-fadeIn">
          Loading workspace...
        </p>
      </div>
    </div>
  );
};

export default Loading;
